/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

'use client';

import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { useTranslation } from '@/lib/i18n';
import { logger } from '@/lib/logger';

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

/**
 * Cray26 Theme - Verify Email Page
 * Modern email verification page with Tailwind CSS styling
 */

export default function VerifyEmailPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const token = searchParams.get('token');
  const { t } = useTranslation();

  useEffect(() => {
    // skipping email verification logic for now
    logger.info({ msg: 'Email verification skipped' });
    setSuccess(true);
    setIsLoading(false);

    // Redirect to login after a delay
    setTimeout(() => {
      router.push('/login?message=' + encodeURIComponent(t('auth.verifyEmail.verificationSuccess')));
    }, 3000);
  }, [router, t('auth.verifyEmail.verificationSuccess')]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100">
                <svg className="h-6 w-6 text-blue-600 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">{t('auth.verifyEmail.verifying')}</h2>
              <p className="mt-2 text-center text-sm text-gray-600">{t('auth.verifyEmail.verifyingMessage')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">{t('auth.verifyEmail.verified')}</h2>
              <p className="mt-2 text-center text-sm text-gray-600">{t('auth.verifyEmail.verifiedMessage')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Error de verificación</h2>
            <p className="mt-2 text-center text-sm text-gray-600">{error}</p>
            <div className="mt-6">
              <Link
                href="/login"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                {t('auth.verifyEmail.backToLogin')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
